import React, { useEffect } from 'react';
import { Loader } from '../loader';
import Footer from '../footer/Footer';
import CardChatECAgi from '../card/CardChatECAgi';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { setECChatId } from './ecChatSlice';
import { useSelector, useDispatch } from 'react-redux';
import uuid from 'react-native-uuid';
import CardSTTSA from '../card/CardSTTSA';
const STTSAPage = (props) => {
	const dispatch = useDispatch();
	const ecChatId = useSelector((state) => {
		console.log('Full Redux State in ECChatPage:', state);
		return state.ecChat?.ecChatId;
	});

	useEffect(() => {
		console.log("EC Chat Page has been mounted");
		const newECChatId = uuid.v4();
		console.log("Generated new EC Chat ID:", newECChatId);
		dispatch(setECChatId(newECChatId));
	}, [dispatch]);

	// useEffect(() => {
	// 	console.log("EC Chat ID in ECChatPage:", ecChatId);
	// }, [ecChatId]);

	return (
		<div className="app-page">
			<div className="title-page">
				<Container>
					<Row>
						<Col xs={2}>
							{/* <img src="./333-logo.png" alt="Logo" /> */}
						</Col>
						<Col xs={8}>
							<h2 align="center">Speech To Text Test for Multi Language</h2>
						</Col>
						<Col xs={2}>
							
						</Col>
					</Row>
				</Container>
			</div>
			<CardSTTSA />
			<Loader />
			{/* <Footer /> */}
		</div>
	);
}

export default STTSAPage;